export const selectMerchant = (state) => state.merchant;
export const selectMerchantId = (state) => state.merchant.item.id;
